import { Injectable } from '@angular/core';
import { HistoryDrawerConfig } from '../models/user-history.model';
import { BehaviorSubject } from 'rxjs';
import { ConfigKeys } from 'src/app/shared/models/configuration';

@Injectable({
  providedIn: 'root',
})
export class StateSettingsHistoryDrawerService {
  private configHistoryDrawerSubject = new BehaviorSubject<HistoryDrawerConfig>(
    this.defaultConfigStatic()
  );
  configHistoryDrawer$ = this.configHistoryDrawerSubject.asObservable();

  constructor() {
    // this.loadConfig();
  }

  get currentConfig(): HistoryDrawerConfig | null {
    return this.configHistoryDrawerSubject.value;
  }

  getCurrentConfig(): HistoryDrawerConfig {
    return this.configHistoryDrawerSubject.value;
  }

  set setConfig(config: HistoryDrawerConfig) {
    this.configHistoryDrawerSubject.next(config);
    localStorage.setItem(ConfigKeys.HISTORY_DRAWER, JSON.stringify(config));
  }

  private loadConfig(): void {
    const savedConfig = localStorage.getItem(ConfigKeys.HISTORY_DRAWER);
    if (savedConfig) {
      this.configHistoryDrawerSubject.next(JSON.parse(savedConfig));
    }
  }

  defaultConfigStatic(): HistoryDrawerConfig {
    return {
      showMovements: false,
      showStops: false,
      showStartRoute: false,
      showEndRoute: false,
      showFrames: false,
      showEvents: false,
      frameVariant: 'basic',
      routeWithDirection: true,
      animationDirection: true,
      routeWithSpeed: false,
      showGeofences: false,
      showCircularGeofences: false,
      showGeopoints: false,
    };
  }
}
